/* tslint:disable */
/* eslint-disable */
/**
 * Modulos Platform API v2
 * API for the Modulos Platform.
 *
 * The version of the OpenAPI document: 2.5.7
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */




export const AssistantApiErrorCode = {
    AssistantDisabled: 'assistant_disabled',
    ScopeForbidden: 'scope_forbidden',
    ConversationNotFound: 'conversation_not_found',
    ConversationBusy: 'conversation_busy',
    NothingToRetry: 'nothing_to_retry',
    InputsScopeMismatch: 'inputs_scope_mismatch',
    OnboardingSnapshotOutsideOnboarding: 'onboarding_snapshot_outside_onboarding',
    InputsUnavailable: 'inputs_unavailable',
    TurnRejected: 'turn_rejected',
    InvalidQuery: 'invalid_query',
    ActionNotFound: 'action_not_found',
    ActionAlreadyDecided: 'action_already_decided',
    InvalidAcceptance: 'invalid_acceptance',
} as const;

export type AssistantApiErrorCode = typeof AssistantApiErrorCode[keyof typeof AssistantApiErrorCode];



